(() => {
  const formTag = 'shopify-forms-embed';
  const styleId = 'mgs-mobile-teaser-offset';
  const globalStyleId = 'mgs-floating-widget-drawer-rules';
  const googleWidgetId = 'google-merchantwidget-iframe-wrapper';
  const salesPopupSelector = '#cb-widget-sales-pop';
  const mobileMediaQuery = '(max-width: 749px)';
  const baseBottom = 16;
  const mobileRestingBottom = 116;
  const hensonPurchaseIds = new Set(["8568081318153", "8568081154313", "8568081121545", "8568081252617", "8568081350921", "8568081187081", "9391441019145", "9208223269129", "9337231442185", "15401746333961", "9181314777353", "15401745809673", "15357013033225", "9181312975113", "15446537437449", "8568081285385", "8597185626377", "9391200239881", "8568081383689", "15401746235657", "9151532040457", "9337231180041", "9394743804169", "9422050033929", "9181313433865", "15626715332873", "15595821007113", "15446537109769", "15441081172233", "15124885143817", "9336253579529", "15031123280137", "15626715398409", "15453360390409", "9232392257801", "15298284683529", "15446537273609", "9151529910537", "9151531647241", "9151532302601", "9208223629577", "15561299198217", "9181312254217"]);
  const availabilityFormIds = new Set(["15401746333961", "9181314777353", "15401746235657", "15453360390409"]);
  const blockerSelectors = [
    '#shopify-pc__banner',
    '#PBarNextFrameWrapper',
  ];
  let scheduled = false;
  let trackUntil = 0;

  const isVisibleBottomBlocker = (element) => {
    const style = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();
    return style.display !== 'none'
      && style.visibility !== 'hidden'
      && Number.parseFloat(style.opacity || '1') > 0
      && rect.width > 0
      && rect.height > 0
      && rect.bottom >= window.innerHeight - 8
      && rect.top < window.innerHeight;
  };

  const mobileBottom = () => {
    if (!window.matchMedia(mobileMediaQuery).matches) return baseBottom;

    return blockerSelectors.reduce((bottom, selector) => {
      const blocker = document.querySelector(selector);
      if (!blocker || !isVisibleBottomBlocker(blocker)) return bottom;
      return Math.max(bottom, Math.ceil(window.innerHeight - blocker.getBoundingClientRect().top + baseBottom));
    }, mobileRestingBottom);
  };

  const applyGlobalRules = () => {
    if (document.getElementById(globalStyleId)) return;

    const style = document.createElement('style');
    style.id = globalStyleId;
    style.textContent = `
      body:has(cart-drawer.active) #google-merchantwidget-iframe-wrapper {
        visibility: hidden !important;
        pointer-events: none !important;
      }
      @media screen and (max-width: 749px) {
        body:has(.mobile-facets__disclosure[open]) #google-merchantwidget-iframe-wrapper,
        body:has(.mobile-facets__disclosure.menu-opening) #google-merchantwidget-iframe-wrapper,
        body:has(#ProductGridContainer .collection.loading) #google-merchantwidget-iframe-wrapper {
          visibility: hidden !important;
          pointer-events: none !important;
        }
      }
    `;
    style.textContent += `
      body:has(.mobile-facets__disclosure[open]) #google-merchantwidget-iframe-wrapper,
      body:has(details[open] .search-modal) #google-merchantwidget-iframe-wrapper,
      body:has(.mobile-facets__disclosure[open]) #cb-widget-sales-pop,
      body:has(details[open] .search-modal) #cb-widget-sales-pop {
        visibility: hidden !important; pointer-events: none !important;
      }
      body:has(.mobile-facets__disclosure[open]) shopify-forms-embed,
      body:has(details[open] .search-modal) shopify-forms-embed,
      body:has(.mobile-facets__disclosure[open]) #cb-widget-sales-pop,
      body:has(details[open] .search-modal) #cb-widget-sales-pop {
        display: none !important;
      }
    `;
    style.textContent += `
      @media screen and (max-width: 749px) {
        body.mgs-henson-purchase-visible #google-merchantwidget-iframe-wrapper,
        body.mgs-henson-purchase-visible #cb-widget-sales-pop,
        body.mgs-henson-purchase-visible #cb-widget-sales-pop * {
          visibility: hidden !important;
          pointer-events: none !important;
        }
        body.mgs-henson-purchase-visible shopify-forms-embed {
          display: none !important;
        }
      }
    `;
    style.textContent += `
      @media screen and (max-width: 989px) {
        body:has(#Details-menu-drawer-container[open]) #google-merchantwidget-iframe-wrapper,
        body:has(#Details-menu-drawer-container[open]) #cb-widget-sales-pop,
        body:has(#Details-menu-drawer-container[open]) #cb-widget-sales-pop * {
          visibility: hidden !important;
          pointer-events: none !important;
        }
        body:has(#Details-menu-drawer-container[open]) shopify-forms-embed {
          display: none !important;
        }
      }
    `;
    style.textContent += `
      @media screen and (max-width: 749px) {
        body:has(cart-drawer.active) #cb-widget-sales-pop,
        body:has(cart-drawer.active) #cb-widget-sales-pop * {
          visibility: hidden !important;
          pointer-events: none !important;
        }
        body:has(cart-drawer.active) shopify-forms-embed {
          display: none !important;
        }
      }
    `;
    style.textContent += `
      @media screen and (max-width: 749px) {
        body:has(main #main-cart-footer:not(.is-empty)) #google-merchantwidget-iframe-wrapper,
        body:has(main #main-cart-footer:not(.is-empty)) #cb-widget-sales-pop,
        body:has(main #main-cart-footer:not(.is-empty)) #cb-widget-sales-pop * {
          visibility: hidden !important;
          pointer-events: none !important;
        }
        body:has(main #main-cart-footer:not(.is-empty)) shopify-forms-embed {
          display: none !important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const applyGoogleWidgetOffset = (bottom) => {
    const widget = document.getElementById(googleWidgetId);
    if (!widget) return;

    const desired = `${bottom}px`;
    if (widget.style.getPropertyValue('bottom') !== desired
        || widget.style.getPropertyPriority('bottom') !== 'important') {
      widget.style.setProperty('bottom', desired, 'important');
    }
  };

  const applyMobileTeaserOffset = (bottom) => {
    document.querySelectorAll(formTag).forEach((formEmbed) => {
      const root = formEmbed.shadowRoot;
      if (!root) return;

      let style = root.getElementById(styleId);
      if (!style) {
        style = document.createElement('style');
        style.id = styleId;
        root.appendChild(style);
      }

      const css = `
        @media screen and (max-width: 749px) {
          #app-embed[data-current-step='tease'][data-position='bottom-left'] {
            bottom: ${bottom}px !important;
          }
        }
      `;
      if (style.textContent !== css) style.textContent = css;
    });
  };

  const hensonPurchaseInfo = () => {
    const info = document.querySelector('main product-info[data-product-id]');
    return info && hensonPurchaseIds.has(info.dataset.productId) ? info : null;
  };

  const applyHensonPurchaseClearance = () => {
    const info = hensonPurchaseInfo();
    const rects = [info?.querySelector('.product-form__buttons')?.getBoundingClientRect()];
    if (availabilityFormIds.has(info?.dataset.productId)) {
      rects.push(info.querySelector('.ems-notify-form')?.getBoundingClientRect());
    }
    const visible = window.matchMedia(mobileMediaQuery).matches && rects.some((rect) => rect
      && rect.width > 0 && rect.height > 0
      && rect.bottom > 0 && rect.top < window.innerHeight);
    document.body.classList.toggle('mgs-henson-purchase-visible', Boolean(visible));
  };

  const applyOffsets = () => {
    scheduled = false;
    applyHensonPurchaseClearance();
    const bottom = mobileBottom();
    applyGoogleWidgetOffset(bottom);
    applyMobileTeaserOffset(bottom);

    if (window.performance.now() < trackUntil) {
      scheduled = true;
      window.requestAnimationFrame(applyOffsets);
    }
  };

  const scheduleApply = (trackForMs = 0) => {
    if (trackForMs > 0) {
      trackUntil = Math.max(trackUntil, window.performance.now() + trackForMs);
    }
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(applyOffsets);
  };

  const handleMutations = () => scheduleApply();

  const start = () => {
    applyGlobalRules();
    if (hensonPurchaseInfo()) {
      window.addEventListener('scroll', () => scheduleApply(), { passive: true });
      window.visualViewport?.addEventListener('resize', () => scheduleApply(), { passive: true });
    }
    scheduleApply();
    new MutationObserver(handleMutations).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'hidden', 'style'],
    });
    window.addEventListener('resize', () => {
      // Close only a search whose header became hidden at a responsive breakpoint.
      document.querySelectorAll('details-modal').forEach((modal) => {
        const search = modal.querySelector('details[open] .search-modal');
        const toggle = modal.querySelector('summary');
        if (search && toggle && toggle.getClientRects().length === 0
            && typeof modal.close === 'function') modal.close(false);
      });
      scheduleApply();
    }, { passive: true });
    if (window.customElements) customElements.whenDefined(formTag).then(scheduleApply);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
